import React from "react";
import { Header, Icon } from "semantic-ui-react";
import SidebarWrapper from "./SidebarWrapper";
import WorldHeritageSiteSidebarPanel from "./WorldHeritageSiteSidebarPanel";

const worldHeritageCategoryColor = (category) => {
  const value = String(category || "").toLowerCase();
  if (value === "cultural") return "#c04a36";
  if (value === "natural") return "#2f8f5b";
  if (value === "mixed") return "#9a6f1f";
  return "#7d8896";
};

export default function WorldHeritageSidebarPanel({
  isVisible,
  isMobile,
  sidebarConfig,
  onClose,
  onHeightChange,
  selectedWorldHeritageSite,
  isLoadingWorldHeritageDetails,
  worldHeritageDetailsError,
  parentWorldHeritageSite,
  isLoadingParentWorldHeritageDetails,
  parentWorldHeritageDetailsError,
  isWorldHeritageComponent,
  onOpenParentSite,
}) {
  const parsedWidth = Number.parseInt(sidebarConfig?.width || "0", 10) || 0;
  const hasUsableDesktopWidth = parsedWidth > 40;
  const sidebarConfigWithFallback = {
    ...sidebarConfig,
    width: hasUsableDesktopWidth ? sidebarConfig?.width : "420px",
    height:
      sidebarConfig?.height && sidebarConfig.height !== "0px" && sidebarConfig.height !== "0"
        ? sidebarConfig.height
        : "60vh",
  };

  return (
    <SidebarWrapper
      isMobile={isMobile}
      sidebarConfig={sidebarConfigWithFallback}
      onClose={onClose}
      onHeightChange={onHeightChange}
      zIndex={506}
      isVisible={isVisible}
    >
      <div
        style={{
          padding: isMobile ? "12px 16px" : "16px 20px",
          borderBottom: "1px solid #ddd",
          background: "#f8f8f8",
        }}
      >
        <Header as="h4" style={{ margin: 0 }}>
          <Icon name="world" />
          World Heritage Site
        </Header>
      </div>

      <div
        style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          padding: isMobile ? "12px 16px" : "16px 20px",
          background: "#f7f9fc",
        }}
      >
        <WorldHeritageSiteSidebarPanel
          open={isVisible}
          isMobile={isMobile}
          selectedWorldHeritageSite={selectedWorldHeritageSite}
          isLoadingWorldHeritageDetails={isLoadingWorldHeritageDetails}
          worldHeritageDetailsError={worldHeritageDetailsError}
          parentWorldHeritageSite={parentWorldHeritageSite}
          isLoadingParentWorldHeritageDetails={isLoadingParentWorldHeritageDetails}
          parentWorldHeritageDetailsError={parentWorldHeritageDetailsError}
          isWorldHeritageComponent={isWorldHeritageComponent}
          worldHeritageCategoryColor={worldHeritageCategoryColor}
          onClose={onClose}
          onOpenParentSite={onOpenParentSite}
          showInlineClose={false}
          sticky={false}
        />
      </div>
    </SidebarWrapper>
  );
}
